import { selectedCycleIdState } from 'modules/pond/stores/atom'
import { useNavigate } from 'react-router-dom'
import { useResetRecoilState } from 'recoil'
import { PATH_DASHBOARD } from 'routes/paths'

export interface PondCycleNavigationState {
  selectCycleId?: string
}

export interface OpenPondCycleTarget {
  farmId: string
  pondId: string
  cycleId?: string
}

/**
 * Opens another pond (optionally a specific cycle). The current cycle selection
 * is cleared first so the new route never fetches a cycle under the wrong
 * pond/farm; the wanted cycle travels via navigation state and PondPageWrapper's
 * cycle-sync effect applies it once that pond's cycle list has it.
 */
export const useOpenPondCycle = () => {
  const navigate = useNavigate()
  const resetSelectedCycleId = useResetRecoilState(selectedCycleIdState)

  return ({ farmId, pondId, cycleId }: OpenPondCycleTarget) => {
    resetSelectedCycleId()
    const state: PondCycleNavigationState = { selectCycleId: cycleId }
    navigate(PATH_DASHBOARD.ponds.detail(farmId, pondId), { state })
  }
}
